import { ReviewQueueView } from "@/features/admin/review-queue/components/ReviewQueueView";

export function ReviewQueuePage() {
  return <ReviewQueueView />;
}
